import { createStore } from "jotai";

const store = createStore();

export default store;
